import { createElement, memo } from "react";
import { Modal, ModalProps } from "../../../ui/Modal";
import { Overlay } from "../../../ui/Overlay";
import { useModal, useModalMessages, WrappedModalProps } from "../ModalContext";

export type ModalContainerProps = {
  overlay?: "single" | "stack"
}

export const ModalContainer = memo<ModalContainerProps>(({ overlay = "stack" }) => {
  const modalPropsList = useModalMessages();

  const { remove } = useModal();

  return (
    <>
      {modalPropsList.map((props: WrappedModalProps, index) => {
        const modalProps: ModalProps = {
          ...props,
          onRequestClose: () => remove(props.messageKey),
          isOpen: true,
        };

        if (overlay === "single") {
          modalProps.overlayElement = (overlayProps, contentEl) => (
            <Overlay key="overlay" {...overlayProps} backgroundType={index === 0 ? "blurred" : "none"}>
              {contentEl}
            </Overlay>
          )
        }

        return createElement(Modal, { ...modalProps, key: props.messageKey });
      })}
    </>
  );
});